import { useNavigate } from 'react-router-dom';
import AccionaButton from '../../components/AccionaButton';
import { useIntl } from 'react-intl';
import PropTypes from '../../utils/propTypes';

const WithBackButton = (Component) => {
  const InnerComponent = (props) => {
    const navigate = useNavigate();
    const intl = useIntl();
    const onBack = () => {
      navigate(props.onBackRoute || -1);
    };
    return (
      <>
        <Component {...props} />
        <div className="row">
          <div className="col-sm-12">
            <AccionaButton
              msg={intl.formatMessage({ id: 'back' })}
              onClick={onBack}
              classIcon="icon fas fa-chevron-left"
              style={{
                float: 'right',
                marginTop: '20px',
                marginRight: '0px',
              }}
            />
          </div>
        </div>
      </>
    );
  };

  InnerComponent.propTypes = {
    onBackRoute: PropTypes.string,
  };

  InnerComponent.defaultProps = {
    onBackRoute: undefined,
  };
  return InnerComponent;
};

export default WithBackButton;
